import { relations } from 'drizzle-orm'
import {
  boolean,
  date,
  integer,
  pgEnum,
  pgTable,
  text,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getMonetaryField,
} from '../common/utils'

export const packageTypeEnum = pgEnum('package_type', [
  'fixed_bundle',
  'configurable_item',
])

export const servicePackages = pgTable(
  'service_packages',
  {
    ...getBaseFields(),
    name: text().notNull(),
    description: text(),
    packageType: packageTypeEnum().notNull().default('fixed_bundle'),
    applicableAreaMin: integer(), // NULL = no minimum
    applicableAreaMax: integer(), // NULL = no maximum
    stripeProductId: text(), // Stripe Product ID for this package
  },
  (table) => getBaseIndexes('service_packages', table),
)

export const servicePackageVersions = pgTable(
  'service_package_versions',
  {
    ...getBaseFields(),
    servicePackageId: getIdReference(() => servicePackages.id),
    versionNumber: integer().notNull(),
    description: text(),
    priceMonthly: getMonetaryField().notNull(),
    validFrom: date().notNull(),
    validUntil: date(),
    isActive: boolean().notNull().default(false),
    stripePriceId: text(),
  },
  (table) => getBaseIndexes('service_package_versions', table),
)

export const servicePackagesRelations = relations(
  servicePackages,
  ({ many }) => ({
    versions: many(servicePackageVersions),
  }),
)

export const servicePackageVersionsRelations = relations(
  servicePackageVersions,
  ({ one, many }) => ({
    servicePackage: one(servicePackages, {
      fields: [servicePackageVersions.servicePackageId],
      references: [servicePackages.id],
    }),
    packageVersionTasks: many(packageVersionTasks),
  }),
)

// Junction table for package versions and tasks
export const packageVersionTasks = pgTable(
  'package_version_tasks',
  {
    ...getBaseFields(),
    servicePackageVersionId: getIdReference(() => servicePackageVersions.id),
    maintenanceTaskId: getIdReference(() => maintenanceTasks.id),
    sortOrder: integer().default(0),
    frequency: text(), // 'monthly', 'quarterly', 'annually', 'fall', 'spring', etc.
  },
  (table) => getBaseIndexes('package_version_tasks', table),
)

export const packageVersionTasksRelations = relations(
  packageVersionTasks,
  ({ one }) => ({
    packageVersion: one(servicePackageVersions, {
      fields: [packageVersionTasks.servicePackageVersionId],
      references: [servicePackageVersions.id],
    }),
    maintenanceTask: one(maintenanceTasks, {
      fields: [packageVersionTasks.maintenanceTaskId],
      references: [maintenanceTasks.id],
    }),
  }),
)

// Import needed for relations - will be defined in maintenanceTask.ts
import { maintenanceTasks } from './maintenanceTask'
